import { Icon } from '@mui/material';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
import Lightbox from "yet-another-react-lightbox";
import Video from "yet-another-react-lightbox/plugins/video";
import {useState} from "react";

import styles from './FeatureGrid.module.css';


function getFeatureBgClasses(i, total) {
  if (total <= 2) {
    switch (i % 4) {
      case 0: return { bg: 'bg-hs-blue-pale', icon: 'bg-hs-blue-light' };
      case 1: return { bg: 'bg-hs-green-pale', icon: 'bg-hs-green-light' };
    }
  }

  switch (i % 4) {
    case 0: return { bg: 'bg-hs-blue-pale', icon: 'bg-hs-blue-light' };
    case 1: return { bg: 'bg-hs-grey-light', icon: 'bg-hs-grey' };
    case 2: return { bg: 'bg-hs-green-pale lg:bg-hs-grey-light', icon: 'bg-hs-green-light lg:bg-hs-grey' };
    case 3: return { bg: 'bg-hs-grey-light lg:bg-hs-green-pale', icon: 'bg-hs-grey lg:bg-hs-green-light' };
  }
}

/**
 * @param {{
 *   features: {
 *     title: string;
 *     body: string;
 *     icong: string;
 *   }[];
 *   className?: string;
 * }} 
 */
export default function FeatureGrid({ features, className, ...props }) {
  const [openStates, setOpenStates] = useState(features.map(() => false));

  function changeOpenState(index, newOpenState) {
    const newStates = [...openStates];
    newStates[index] = newOpenState;
    setOpenStates(newStates);
  }

  return (
    <div
      className={twMerge(classNames([
        'grid grid-cols-1 lg:grid-cols-2 gap-12 mt-40',
        className
      ]))}
    >
      {features.map((feature, i) => {
        const bgClasses = getFeatureBgClasses(i, features.length);

        return (
          <article
            key={i}
            className={classNames([
              'p-20 lg:p-40 pb-20 lg:pb-40 rounded-20 flex flex-col relative w-full',
              bgClasses.bg
            ])}
          >
            <div className="flex-grow">
              <div className="flex justify-between items-start">
                <h3 className="h4 lg:h2 wrap-break-word min-w-0">
                  {feature.title}
                </h3>

                <div className={classNames([
                  'w-60 h-60 lg:w-80 lg:h-80 flex justify-center items-center rounded-full text-hs-white text-32 lg:text-40 flex-none ml-20',
                  bgClasses.icon
                ])}>
                  {feature.icon.includes("material") ?
                    <FuseSvgIcon size='40px'>{feature.icon}</FuseSvgIcon>
                                    :
                    <Icon fontSize='inherit'>{feature.icon}</Icon>
                  }
                </div>
              </div>

              <p className="body-md lg:body-lg mt-28">
                {feature.body}
              </p>
            </div>
            { feature.screenshots  &&
              <div className={styles.imageContainer}>
                <button className={styles.aspectRatioContainer}
                  onClick={() => changeOpenState(i, true)}
                >
                  <img
                      className={styles.image}
                      src={feature.screenshotPreview}
                  />
                  {feature.screenshots[0].type === 'video' && <div className={styles.playButton} />}

                </button>

                <Lightbox
                  open={openStates[i]}
                  plugins={[Video]}
                  close={() => changeOpenState(i, false)}
                  slides={feature.screenshots}
                />
              </div>
            }
          </article>
        );
      })}
    </div>
  )
}